import { BooleanInput, Button, useNotify, useRefresh } from "react-admin";
import Edit from "@mui/icons-material/Edit";
import { studentRequests } from "api/studentApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ChangeUsesDormitory = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const recordData = record?.usesDormitory;

  const handleSent = async data => {
    await dataProvider.customRequest(
      studentRequests.updateDormitoryUsage(record?.studentId),
      { uses: data.usesDormitory },
      "PUT",
    );
    refresh();
    notify(`Успешна редакция на общежитие`, { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Редакция на общежитие"}
      onConfirm={handleSent}
      defaultValues={{ usesDormitory: recordData }}
      triggerButton={
        <Button
          label="Редакция на общежитие"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <BooleanInput
        source="usesDormitory"
        label="Ползва общежитие"
      />
    </FormModal>
  );
};

export default ChangeUsesDormitory;
